"use strict";
import Vue from 'vue';
import Dashboard from './components/Dashboard.vue';
Vue.config.productionTip = false;
export { Dashboard };
